/**
 * Business events written against a rental snapshot.
 * `purged` is written only by the renter wipe.
 */
export enum RentalSnapshotEventEnum {
	PRINTED = 'printed',
	EMAILED = 'emailed',
	EMAIL_FAILED = 'email_failed',
	E_SIGNATURE_SENT = 'e_signature_sent',
	E_SIGNATURE_COMPLETED = 'e_signature_completed',
	CHECKED_OUT = 'checked_out',
	CHECKED_IN = 'checked_in',
	CANCELLED = 'cancelled',
	ACCEPTED = 'accepted',
	REJECTED = 'rejected',
	PURGED = 'purged',
}
